import { BIconArrowReturnRight } from "bootstrap-vue"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["cs", "h", "hi", "hd", "k", "ki", "kd"]

  connect() {
    this.recalc()
  }

  recalc() {
    const cs = this.num(this.csTarget?.value)

    // PLANO
    if (this.hasHTarget && this.hasKTarget) {
      const value = this.calcK(this.num(this.hTarget.value), cs)
      this.kTarget.value = value
      this.setBorderColor(this.kTarget, value)
    }

    // DESNIVELES
    if (this.hasHiTarget && this.hasKiTarget) {
      const value = this.calcK(this.num(this.hiTarget.value), cs)
      this.kiTarget.value = value
      this.setBorderColor(this.kiTarget, value)
    }

    if (this.hasHdTarget && this.hasKdTarget) {
      const value = this.calcK(this.num(this.hdTarget.value), cs)
      this.kdTarget.value = value
      this.setBorderColor(this.kdTarget, value)
    }
  }

  calcK(hight, cs) {
    if (hight == null || cs == null) return 0

    const result = hight - cs

    return result
  }

  num(value) {
    const number = parseFloat(value)
    return isNaN(number) ? null : number
  }

  setBorderColor(target, value) {
    if (value > 0) {
      target.classList.add("border-success")
      target.classList.remove("border-danger")
    } else {
      target.classList.add("border-danger")
      target.classList.remove("border-success")
    }
  }
}
